import { combineReducers } from 'redux'
import mainView from './reducers/mainView'

export default combineReducers({
  mainView,
})
